import React from "react";

/* Reusable animated starfield + ambient glow background.
   Must be rendered as a direct child of a `relative` (or otherwise
   positioned) wrapper that spans the area you want it to cover —
   e.g. <div className="relative min-h-screen ..."><Starfield />...</div>
   Uses `absolute` (not `fixed`) so it's never trapped or hidden by an
   ancestor's transform/animation (a common CSS gotcha with `fixed`). */
export default function Starfield() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      {[...Array(120)].map((_, i) => (
        <div
          key={i}
          className="absolute rounded-full bg-white"
          style={{
            width: Math.random() * 2 + 1 + "px",
            height: Math.random() * 2 + 1 + "px",
            top: Math.random() * 100 + "%",
            left: Math.random() * 100 + "%",
            opacity: Math.random() * 0.5 + 0.3,
          }}
        />
      ))}
      <div className="absolute -top-40 left-1/2 h-96 w-[36rem] -translate-x-1/2 rounded-full bg-orange-600/10 blur-[120px]" />
      <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-orange-500/10 blur-[100px]" />
    </div>
  );
}